import { ReactNode, forwardRef } from "react";
import { Heading3 } from "../typography";

interface ScrollItemProps {
  children: ReactNode;
  title: string;
  description: string;
  className?: string;
}

export const ScrollItem = forwardRef<HTMLDivElement, ScrollItemProps>(
  ({ children, title, description, className = "" }, ref) => {
    return (
      <div ref={ref} className={`scroll-item flex-shrink-0 ${className}`}>
        <div className="relative w-full lg:w-[1060px] lg:h-[530px] bg-white/20 border border-gray-500 px-6 py-8 lg:px-18 2xl:py-16 rounded-2xl sizing-border max-w-[90vw] max-h-[90vh] lg:max-h-[50vh] backdrop-blur-xs text-white text-center overflow-hidden">
          {children}
          <Heading3 className="mt-6 2xl:mt-11 mb-5">{title}</Heading3>
          <p className="md:text-xl lg:text-2xl m-0 whitespace-break-spaces">
            {description}
          </p>
          <div
            className="progress-bar h-1 bg-gradient-to-r from-haizea-blue to-haizea-green absolute bottom-0 left-0 w-full"
            style={{
              clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
            }}
          ></div>
        </div>
      </div>
    );
  }
);

ScrollItem.displayName = "ScrollItem";
